import { useQuery, useQueryClient } from '@tanstack/react-query'
import { LoadingState } from '@cinesend/ui-kit'
import FieldValue from '../field_value'
import SettingsCard from '../settings_card'
import { DETAILS_FIELD_NAMES, MEDIA_FIELD_NAMES, matchesFieldName } from './field_groups'

const OtherFields = ({ asset, cycleID }) => {
  const queryClient = useQueryClient()
  const queryKey = [`field-values`, `?assetID=${asset.id}`, `&cycleID=${cycleID}`]
  const { data: fields, isLoading } = useQuery(queryKey)
  const refreshValues = () => queryClient.invalidateQueries(queryKey)

  if (isLoading) {
    return (
      <SettingsCard title='Other'>
        <LoadingState className='justify-center' />
      </SettingsCard>
    )
  }

  const visibleFields =
    fields?.filter(
      (field) =>
        !matchesFieldName(DETAILS_FIELD_NAMES, field.name) &&
        !matchesFieldName(MEDIA_FIELD_NAMES, field.name) &&
        field.field_type !== 'image'
    ) ?? []

  if (visibleFields.length === 0) return null

  return (
    <SettingsCard title='Other'>
      <div className='grid gap-4 sm:grid-cols-2'>
        {visibleFields.map((field) => (
          <div key={field.id} id={`field-${field.name?.toLowerCase()?.replaceAll(' ', '-')}`}>
            <FieldValue
              cacheKey={queryKey}
              field={field}
              assetID={asset.id}
              cycleID={cycleID}
              refreshValues={refreshValues}
            />
          </div>
        ))}
      </div>
    </SettingsCard>
  )
}

export default OtherFields
